import { API } from "aws-amplify";

const API_PATH = 'organization-consent';

export function checkOrganizationConsentAPI() {
  return API.get(API_PATH, "/check");
}

export function addOrganizationConsent(organizationConsent) {
  return API.post(API_PATH, "/add", {
    body: organizationConsent
  });
}

export function revokeOrganizationConsent(organizationConsent) {
  return API.put(API_PATH, "/revoke", {
    body: organizationConsent
  });
}

export function unrevokeOrganizationConsent(organizationConsent) {
  return API.put(API_PATH, "/unrevoke", {
    body: organizationConsent
  });
}

export function getNonOverreadPatients(organizationID) {
  return API.get(API_PATH, `/overread/${organizationID}`);
}

export function getOrganizationConsentForPatient(organizationID, patientID) {
  return API.get(API_PATH, `/${organizationID}/${patientID}`);
}

export function removeOrganizationConsent(organizationID, patientID) {
  return API.get(API_PATH, `/remove/${organizationID}/${patientID}`)
}

export function removeOrganizationConsentForPatient(patientID) {
  return API.get(API_PATH, `/remove/patient/${patientID}`);
}

export function removeAllOrganizationConsent(organizationID) {
  return API.get(API_PATH, `/remove/organization/${organizationID}`);
}

export function getAllOrganizationConsents(organizationID) {
  return API.get(API_PATH, `/patients/${organizationID}`);
}

export function getOrganizationConsent(patientID) {
  return API.get(API_PATH, `/patient/${patientID}`);
}

// Redundant - did Chris remove this?
export function getAllConsentRecords(patientID) {
  return API.get(API_PATH, `/patient/all-consents/${patientID}`);
}

export function getNotConsentedPatients(organizationID) {
  return API.get(API_PATH, `/patients/not-accepted/${organizationID}`);
}

export function acceptConsent(organizationID, patientID) {
  return API.get(API_PATH, `/accept/${organizationID}/${patientID}`);
}

export function rejectConsent(organizationID, patientID) {
  return API.get(API_PATH, `/reject/${organizationID}/${patientID}`);
}

export function updateReminders(organizationID, patientID, reminders) {
  return API.post(API_PATH, `/${organizationID}/${patientID}`, {
    body: { reminders }
  });
}

export function getActiveOrganizationIDsForPatient(patientID) {
  return API.get(API_PATH, `/organizations/active/${patientID}`);
};

export function registerSeriesAsBaseline(organizationID, patientID, seriesID, baselineParam) {
  return API.post(API_PATH, `/baseline/${organizationID}/${patientID}`, {
    body: {
      seriesID,
      baselineParam
    }
  });
};

export function getBaselinesForPatient(organizationID, patientID) {
  return API.get(API_PATH, `/baseline/${organizationID}/${patientID}`);
};

export function acknowledgeTrendForPatient(organizationID, patientID, parameter, trendType, seriesID, undoReview = false) {
  const body = {
    parameter,
    trendType,
    seriesID,
    undoReview
  };
  return API.post(API_PATH, `/trends/${organizationID}/${patientID}`, { body });
};

/**
 * @param {string} organizationID
 * @param {string} patientID
 * @param {string} providerID
 */
export function markPatientAsTrained(organizationID, patientID, providerID) {
  const body = { trained: { providerID, timestamp: Date.now() } };
  return API.post(API_PATH, `/${organizationID}/${patientID}`, { body });
};

/**
 *
 * @param {string} organizationID
 * @param {string} patientID
 * @param {any} body
 */
export function updateOrganizationConsent(organizationID, patientID, body) {
  return API.post(API_PATH, `/${organizationID}/${patientID}`, { body });
}